module.exports = __webpack_public_path__ + "img/bda08d08691f2afb5d13172b63b15a4e.png";